/**
 * @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-v2.json
 */
const Session = {
    // TODO - add all, use where possible
    id:             { key: 'id',   name: 'ID' },
    ownerID:        { key: 'ownerID',  name: 'Owner ID' },
    createDate:     { key: 'createDate',   name: 'Create Date' },
    sessionTypeID:  { key: 'sessionTypeID',   name: 'sessionTypeID' },
    sessionType:    { key: 'sessionType',  name: 'sessionType' },
    status:         { key: 'status',   name: 'status' },
    gameStatus:     { key: 'gameStatus',   name: 'gameStatus' },
    isOfficial:     { key: 'isOfficial',   name: 'isOfficial' },
    parameters:     { key: 'parameters',   name: 'parameters' },
    lineups:        { key: 'lineups',   name: 'lineups' },
    results:        { key: 'results',   name: 'results' },
};

export default Session;